import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialisation au chargement
  useEffect(() => {
    console.log('🔄 Initialisation AuthContext...');
    
    const initAuth = () => {
      try {
        if (authService.isAuthenticated()) {
          const currentUser = authService.getCurrentUser();
          console.log('👤 Utilisateur trouvé en localStorage:', currentUser);
          setUser(currentUser);
        } else {
          console.log('🔒 Aucun utilisateur connecté');
        }
      } catch (error) {
        console.error('❌ Erreur initialisation auth:', error);
        authService.logout();
      } finally {
        console.log('✅ AuthContext initialisé');
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  // Fonction de connexion SIMPLIFIÉE
  const login = async (credentials) => {
    console.log('🚀 Début login...');
    
    try {
      setLoading(true);
      setError(null);
      
      console.log('📤 Envoi credentials...');
      const response = await authService.login(credentials);

    if ( response.user.isActive !== true || response.user.isPartner !== true) {
      authService.logout();
      throw new Error('Accès réservé aux administrateurs');
    }

      console.log('📥 Réponse reçue:', response);
      
      if (response && response.user) {
        console.log('✅ Setting user:', response.user);
        setUser(response.user);
        return response;
      } else {
        throw new Error('Réponse invalide du serveur');
      }
      
    } catch (error) {
      console.error('❌ Erreur dans login:', error);
      setError(error.message);
      throw error;
    } finally {
      console.log('🏁 Fin login, loading: false');
      setLoading(false);
    }
  };

  const logout = () => {
    console.log('🚪 Déconnexion...');
    setUser(null);
    setError(null);
    authService.logout();
  };

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin' || user?.admin === true,
    isPartner: user?.isPartner === true,  
    clearError: () => setError(null)
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};